import { Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from "@material-ui/core";
import React from "react";
import { PortimaConnectUserInfo } from "../../../../models/user-info.model";
import i18next from "../../../../assets/i18n/i18n";
import "./user-info-panel.scss";

type Props = {
    userInfo: PortimaConnectUserInfo;
};

const UserInfoPanel = ({ userInfo }: Props): React.ReactElement => {
    return (
        <TableContainer
            component={Paper}
            style={{ boxShadow: "none", marginBottom: "2em", backgroundColor: "#ffffffb9" }}
        >
            <Table className="user-info-table">
                <TableHead>
                    <TableRow>
                        <TableCell className="user-info-table-head">{i18next.t("UserInfoPanel.Header")}</TableCell>
                        <TableCell />
                        <TableCell />
                    </TableRow>
                </TableHead>
                <TableBody>
                    <TableRow>
                        <TableCell align="left" className="user-info-table-body-header">
                            {i18next.t("UserInfoPanel.CurrentUser")}
                        </TableCell>
                        <TableCell align="left" className="user-info-table-body-data">{`${userInfo.name}`}</TableCell>
                        <TableCell />
                    </TableRow>
                    {userInfo.phoneNumber !== "" ? (
                        <TableRow>
                            <TableCell align="left" className="user-info-table-body-header">
                                {i18next.t("UserInfoPanel.PhoneNumber")}
                            </TableCell>
                            <TableCell align="left" className="user-info-table-body-data">
                                {userInfo.phoneNumber}
                            </TableCell>
                            <TableCell />
                        </TableRow>
                    ) : (
                        ""
                    )}
                </TableBody>
            </Table>
        </TableContainer>
    );
};

export default UserInfoPanel;
